import classes from './Pricing.module.css';
import React from 'react';
import { useState } from "react";
import { Center, Switch, Space, Flex, Text, Container, SimpleGrid, GridCol, Grid } from '@mantine/core';
import { BigButton, VerticalButton } from './VerticalButton';
import I18n from "../../i18n.js";
export const dynamicPricingList = 
    [
        {
            header: "Personal",
            subheader: "Perfect for individual racers",
            priceMonthly: 9.98,
            priceYearly: 5.98,
            currency: "€",
            features: ["70+ ACADEMY Modules", "Real-time Feedback", "Track Learning System", "Setup Optimizer Tool"],
            button: I18n.t("general.learnMore")
        },
        {
            header: "Team",
            subheader: "Equip your whole team with the potential to improve.",
            priceMonthly: 29.98,
            priceYearly: 14.98,
            currency: "€",
            features: ["4 licenses", "Everything in Personal ", "Schedule Team Events", "Team Goal Tracking"],
            button: I18n.t("general.learnMore")
        },
        {
            header: "Enterprise",
            subheader: "For larger scale operations and communities with many drivers.",
            priceMonthly: null,
            priceYearly: null,
            currency: "let’s talk",
            features: ["Custom license amount", "Community Data API", "Priority Support", "Group Coachings"],
            button: I18n.t("general.learnMore")
        }
    ];
export function PricingModule() {
    
    return (
        <>
            <Container fluid display="flex" className={classes.pricingContainer} >
                <BigButton
                    button="button"
                    header="" 
                    subheader=""
                    price={30}
                    currency="€"
                    paycycle=""
                    features={["pricing.features.feature1", "pricing.features.feature2", "pricing.features.feature3"]}/>
            </Container>
        </>
    );
}